import React, { useEffect } from 'react';
import { CenterFrameLayout } from 'Layouts';
import { signOut } from 'State/User';
import { handleSignOut } from 'Utils/MVPD';
import { segmentTrackEvent, tealiumTrackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { logger } from 'Utils/Logger';
import { useStore } from 'Hooks/useStore';

export function SignOutContainer() {
  const { defaultConfig } = useStore('appConfig');
  const { rootDomain } = defaultConfig;

  // set redirect path
  const url = new URL(window.location.href);
  const hasReturnTo = url.searchParams.has('return_to');
  const isLocalhost = window.location.hostname.includes('local');
  let redirectUri;
  let path = !isLocalhost ? rootDomain : '/';
  if (hasReturnTo) {
    path = url.searchParams.get('return_to');
  }

  const isExternalLink = !!path.match(/http/i);

  if (path) {
    if (isExternalLink || path === rootDomain) {
      redirectUri = path;
    } else {
      redirectUri = `${window.location.origin}${path}`;
    }
  }

  useEffect(() => {
    async function logout() {
      logger.started('signout');
      segmentTrackEvent(TRACKING_ENUMS.EVENT_LOGOUT_STARTED);
      tealiumTrackEvent(TRACKING_ENUMS.EVENT_LOGOUT);
      try {
        await handleSignOut({
          profileSignOut: () =>
            signOut(false, {
              ...(redirectUri ? { redirectUri } : {}),
            }),
        });
        segmentTrackEvent(TRACKING_ENUMS.EVENT_LOGOUT_COMPLETED);
        segmentTrackEvent(TRACKING_ENUMS.EVENT_PROFILE_LOGGED_OUT);
      } catch (error) {
        logger.error('signout', error);
      }
    }
    logout();
  }, [rootDomain, redirectUri]);

  return <CenterFrameLayout title="Signing out..." showLoader />;
}
